import React, { Component } from 'react';
import { connect } from 'react-redux';
import PT from 'prop-types';
import { Form, Message } from 'semantic-ui-react';
import {
  handleSubmitUsernameRequest,
  selectRequestUsernameState,
  resetView,
} from './module/requestUsername';
import classes from './requestUsername.css';
import keyIcon from '../../../assets/images/key.png';
import Link from '../../../lib/components/link';
import { GO_LOGIN } from '../../../store/actions/auth.types';
import { gciPageView } from '../../../lib/analytics';

const pageTitle = 'Forgot your username? Request a reminder';

class RequestUsername extends Component {
  static propTypes = {
    handleSubmitUsernameRequest: PT.func.isRequired,
    resetView: PT.func.isRequired,
    submissionSuccess: PT.bool,
    error: PT.bool,
    gciPageView: PT.func.isRequired,
  };

  state = { email: '' };

  componentWillUnmount() {
    this.props.resetView();
  }

  componentDidMount() {
    document.title = pageTitle + ' - TheHuddle';
    gciPageView(pageTitle);
  }

  handleEmailChange = (e, { name, value }) => {
    this.setState({ [name]: value });
  };

  handleSubmit = () => {
    this.props.handleSubmitUsernameRequest(this.state.email);
  };

  render() {
    const { email } = this.state;
    const { submissionSuccess, error } = this.props;
    return (
      <div className={classes.formContainer}>
        <div className={classes.headingContainer}>
          <div className={classes.heading}>Forgot your username?</div>
          <div>
            <img src={keyIcon} alt="" />
          </div>
        </div>
        <p className={classes.text}>
          It’s no problem. Enter the email associated with your account. We’ll send you your username.
        </p>

        <Form
          onSubmit={this.handleSubmit}
          success={submissionSuccess}
          error={submissionSuccess === false}
        >
          <Form.Input
            className={classes.emailInput}
            onChange={this.handleEmailChange}
            required
            type="email"
            name="email"
            value={email || ''}
            placeholder="E-mail address"
          />
          <Message
            success
            header="E-mail sent!"
            content="Check your inbox for an e-mail containing your username."
          />
          <Message
            error
            header="Error"
            content={
              error ? (
                error.message
              ) : (
                'There was an error. Please try again later.'
              )
            }
          />
          <Form.Button primary fluid>
            Continue
          </Form.Button>
        </Form>
        <div>
          <Link
            className={classes.link}
            to={{ type: GO_LOGIN }}
            label="Go back to sign in"
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { error, submissionSuccess } = selectRequestUsernameState(state);
  return { error, submissionSuccess };
};

const mapDispatchToProps = {
  handleSubmitUsernameRequest, resetView,
};

export default connect(mapStateToProps, mapDispatchToProps)(RequestUsername);



// WEBPACK FOOTER //
// ./src/app/views/UsernameRequest/RequestUsername.js